import { render, staticRenderFns } from "./storeDeliveryList.vue?vue&type=template&id=07a47c12&scoped=true"
import script from "./storeDeliveryList.vue?vue&type=script&lang=js"
export * from "./storeDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./storeDeliveryList.vue?vue&type=style&index=0&id=07a47c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a47c12",
  null
  
)

export default component.exports